// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"6aa2d4b2","787":"f2f6109b"}[chunkId] + ".chunk.js";
};